var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":function($event){return _vm.downloadJson()}}},[_vm._v("download")])])
}
var staticRenderFns = []

export { render, staticRenderFns }